// @ts-check
'use_strict';

import { load_js_async } from '../tv_utils/utils.js';
declare var get_google_maps_url;


/**
 * Function to check for Google Autocomplete specific elements.
 * If these elements exist, then we can start initializing Google Autocomplete for each one.
 */
export async function initialize_google_autocomplete(in_modal : boolean = false) : Promise<void> {
    const prefixes = document.getElementsByClassName('js-google-autocomplete-prefix');
    if (prefixes.length) {
        // Open shadow to allow access to google places autocomplete elements.
        const attachShadow = Element.prototype.attachShadow;
        Element.prototype.attachShadow = function (init: ShadowRootInit) {
            if (this.localName === "gmp-place-autocomplete") {
                // Override the default behavior of attachShadow() to set the mode to open.
                const shadow = attachShadow.call(this, {
                    ...init,
                    mode: "open"
                });
                const style = document.createElement("style");
                // Hide the built-in focus ring.
                style.textContent = `
                    .focus-ring {
                        display: none !important;
                    }
                `;
                shadow.appendChild(style);
                return shadow;
            }
            return attachShadow.call(this, init);
        };

        const [module, loaded] = await Promise.all([
            import('./google_autocomplete'),
            //@ts-ignore
            google.maps.importLibrary('places') as google.maps.PlacesLibrary
        ]);
        if (loaded) {
            for (const ap of prefixes) {
                const address_prefix = <HTMLInputElement> ap;
                // If the Address Prefix is valid, start the Google Autocomplete.
                if (address_prefix.value) {
                    new module.GoogleAutocomplete(address_prefix.value, in_modal);
                }
            }
        }
    }
}
